<!-- Translated: yes -->
<template>
  <Modal class="modal-relative" @close="closeModal" :wide="false" width="520px">
    <p class="required-notice"><span>*</span> {{ $t('general.mandatory-fields') }}</p>

    <div v-if="!$store.state.isOnSite">
      <!--<h1 v-if="!people[0].delivery && SITE_CONFIG.accomodations.show_site">Vart vill du hämta din utrustning?<span class="required">*</span></h1>-->
      <label
        v-if="!people[0].delivery && SITE_CONFIG.accomodations.show_site" :class="'uppercase ' + ($store.state.isOnSite ? '' : '')"
        @click="openModal(['SkiSchoolLocationMap', {markers: SITE_CONFIG.rental.coordinates}])"
        style="cursor:pointer;"
        >
        {{ $t('general.extradition-point') }} <icon name="info-blue-white-bg" :scale="1.3" /> <span v-if="!$store.state.isOnSite" class="required">*</span></label>

      <div v-if="!people[0].delivery && SITE_CONFIG.accomodations.show_site" :class="'box places ' + ($store.state.isOnSite ? '' : '') + (showError('place') ? ' box-error' : '')">
        <div v-if="!$store.state.isOnSite || site == 1">
          <icon name="byn" :scale="1.8" /> {{ $t('general.sites.valley') }}
          <Checkbox v-if="!$store.state.isOnSite" :label="''" :value="1" :valuebinder.sync="site" />
        </div>
        <div v-if="!$store.state.isOnSite || site == 2">
          <icon name="berget" :scale="1.8" /> {{ $t('general.sites.top') }}
          <Checkbox v-if="!$store.state.isOnSite" :label="''" :value="2" :valuebinder.sync="site" />
        </div>
      </div>
    </div>

    <div v-if="showTimePicker">
      <label class="uppercase">{{ $t('general.pick-time') }}<span class="required">*</span></label>
      <p v-if="['vallasen', 'ulricehamn'].indexOf(SITE_CONFIG.site) !== -1">På grund av rådande restriktioner och er säkerhet har vi valt att begränsa antalet hyrutrustningar som lämnas ut vid en viss tidpunkt. Det är därför viktigt att ni här nedanför väljer den tid ni tänkt hämta er utrustning och är noga med att komma på utsatt tid.</p>
      <div :class="'box checkboxes' + (showError('time') ? ' box-error' : '')">
        <div v-for="time in times" :class="(!time.available) ? 'disabled' : ''">
          <Checkbox
            :label="(time.title)"
            :sublabel="((time.available && ['vallasen', 'ulricehamn'].indexOf(SITE_CONFIG.site) !== -1) ? ('' + time.available + ' kvar') : '')"
            label-position="after"
            :value="time.value"
            :valuebinder.sync="pickupTime"
            />
        </div>
      </div>
    </div>

    <label class="uppercase">{{ $t('general.mobilephonenumber') }} ({{ $t('general.for-sms') }})<span class="required">*</span></label>
    <div :class="'box phone' + (showError('phone') ? ' box-error' : '')">
      <input type="tel" v-model="phone" @blur="fixPhone" />
      <div class="phone-number">{{ $t('general.obs-format', {format: '+46701234567'}) }}</div>
    </div>

    <div class="receipt-wrapper" v-if="showReceiptPicker">
      <label class="uppercase">{{ $t('general.digital-receipt') }}<span class="required">*</span></label>
      <div :class="'box checkboxes' + (showError('receipt') ? ' box-error' : '')">
        <Checkbox :label="$i18n.t('general.yes')" label-position="right" :value="true" :valuebinder.sync="receipt"></Checkbox>
        <Checkbox :label="$i18n.t('general.no')" label-position="right" :value="false" :valuebinder.sync="receipt"></Checkbox>
      </div>
    </div>

    <div :class="'box insurance' + (showError('insurance') ? ' box-error' : '')" v-if="showInsurance">
      <h3 @click="openPdf()" style="cursor:pointer;">
        <icon name="avbestallning" :scale="2" /><span>{{ $t('skirental.insurance.title') }}<span class="required">*</span> <icon name="info-blue-white-bg" :scale="1" /> </span>
      </h3>
      <p v-if="SITE_CONFIG.site === 'branas'">{{ $t('skirental.insurance.branas') }}</p>
      <p v-if="SITE_CONFIG.site === 'kungsberget'">{{ $t('skirental.insurance.kungsberget') }}</p>
      <p v-if="SITE_CONFIG.site === 'vallasen'">{{ $t('skirental.insurance.vallasen') }}</p>
      <p v-if="SITE_CONFIG.site === 'ulricehamn'">{{ $t('skirental.insurance.ulricehamn') }}</p>
      <p v-if="SITE_CONFIG.site === 'storstenshojden'">{{ $t('skirental.insurance.branas') }}</p>
      <p v-if="SITE_CONFIG.site === 'tolvmannabacken'">{{ $t('skirental.insurance.branas') }}</p>
      <div class="insurance-table">
        <div class="tr" v-for="person in people" v-if="offerInsurance(person)">
          <div class="name">
            {{person.name}}
            <b>{{insuranceSum(person) | currency}}</b>
          </div>
          <div class="checkboxes">
            <Checkbox :class="{error: markInsurance}" :label="$i18n.t('general.yes')" label-position="left" :value="true" :valuebinder.sync="person.insurance"></Checkbox>
            <Checkbox :class="{error: markInsurance}" :label="$i18n.t('general.no')" label-position="left" :value="false" :valuebinder.sync="person.insurance"></Checkbox>
          </div>
        </div>
        <div class="tr summarizer">
          <!--<div>
          </div>-->
          <div>
            <span>{{ $t('skirental.insurance.total') }}</span>&nbsp;<b>{{totalPrice | currency}}</b>
          </div>
        </div>
      </div>

    </div>

    <div class="box info" v-if="canUseCode && $store.state.isOnSite">
      <p>{{ $t('skirental.pay-cash') }}</p>
    </div>

    <div class="box info" v-if="SITE_CONFIG.site === 'storstenshojden'">
      <p>Förbokad skidutrustning hämtas i skiduthyrningen i södra Storstenshöjden.</p>
    </div>

    <div class="box info" v-if="SITE_CONFIG.site === 'vallasen' && onlySkipass">
      <p>{{ $t('skirental.only-skipass') }}</p>
    </div>

    <div class="box info" v-if="productsAvailable === null">
      <p>Kontrollerar tillgänglighet...</p>
    </div>

    <div class="center">
      <button :class="'small white border ' + (!validated ? 'disabled' : '')" @click="openCodeModal()" v-if="canUseCode">{{$store.state.isOnSite ? $i18n.t('general.pay-cash') : $i18n.t('general.pay-with-code')}}</button>
      &nbsp;
      <button :class="(!validated ? 'disabled' : '') + ' ' + 'margin-bottom'" @click="addToCart()">{{$store.state.isOnSite ? $t('general.pay-with-card') : $t('general.add-to-cart')}}</button>
      <button :class="'small white border ' + (!validated ? 'disabled' : '')" @click="openCodeModal(true)" v-if="canUseCode && (SITE_CONFIG.site === 'vallasen' || SITE_CONFIG.site === 'ulricehamn') && $store.state.isOnSite">{{ $i18n.t('general.pay-with-code') }}</button>
    </div>

  </Modal>
</template>

<script>
import API from '@/classes/API';

import Modal from '@/components/components/Modal';
import SwitchButton from '@/components/components/SwitchButton';
import Checkbox from '@/components/components/Checkbox';
import { mapMutations } from 'vuex';

import moment from 'moment';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    SwitchButton,
    Checkbox,
  },
  data() {
    return {
      site: null,
      insurance: null,
      markInsurance: false,
      pickupTime: null,
      phone: null,
      errors: {},
      touched: {},
      onlySkipass: false,
      receipt: false,
      productsAvailable: null,
      times: [],
    };
  },
  async mounted() {
    this.site = parseInt(this.$store.state.isOnWhichSite, 10);

    if (!this.site) {
      this.site = this.people[0].site;
    }
    this.pickupTime = this.people[0].pickupTime;
    if (['branas', 'kungsberget', 'vallasen', 'ulricehamn'].indexOf(this.SITE_CONFIG.site) === -1) {
      this.pickupTime = 9;
    }

    this.phone = this.people[0].phone;

    this.receipt = this.$store.state.cart.receipt;

    if (!this.phone) {
      this.phone = '+46';
    }

    const { only } = await API.frontendHelper('skirental/check-for-only-skipasses', this.$store.state);
    this.onlySkipass = only;

    if (['vallasen', 'ulricehamn'].indexOf(this.SITE_CONFIG.site) !== -1) {
      const arrival = moment(this.people[0].startDate).format('YYYY-MM-DD');
      const priceType = this.people[0].priceType;

      const { data } = await API.get(`skiletting/timeslots/${arrival}?price-type=${priceType}`);
      this.times = data.map((time) => {
        const newTime = JSON.parse(JSON.stringify(time));
        newTime.title = time.label;
        newTime.value = time.time;
        newTime.available = time.available;
        return newTime;
      });
    } else {
      this.times = this.SITE_CONFIG.rental.pickuptimes.map((time) => {
        const newTime = JSON.parse(JSON.stringify(time));
        newTime.available = 50;
        return newTime;
      });
    }

    this.checkAvailability();
  },
  computed: {
    showReceiptPicker() {
      return this.$store.state.isOnSite;
    },
    showInsurance() {
      let count = 0;
      let countOverride = 0;

      this.people.forEach((person) => {
        count += person.addons.filter(a => !a.buy).length;
        countOverride += this.offerInsurance(person);
      });
      this.people.forEach((person) => {
        count += person.products.filter(a => !a.buy).length;
        countOverride += this.offerInsurance(person);
      });

      if (!countOverride) {
        return false;
      }

      return count;
    },
    people() {
      return this.$store.state.cart.rentals.filter(a => a.guideCompleted);
    },
    firstBookingIsToday() {
      const rentals = this.$store.state.cart.rentals.map(a => moment(a.startDate).toDate()).sort();
      const first = moment(rentals[0]).format('YYYY-MM-DD');
      return first === moment().format('YYYY-MM-DD');
    },
    canUseCode() {
      return false;
      // if (!this.SITE_CONFIG.pay_on_site) {
      //   return false;
      // }

      // const accomodations = this.$store.state.cart.accomodations.filter(a => a.confirmed).length;
      // const addons = this.$store.state.cart.addons.filter(a => a.confirmed).length;
      // // const rentals = this.$store.state.cart.rentals.filter(a => a.confirmed).length;
      // const skipasses = this.$store.state.cart.skipasses.filter(a => a.confirmed).length;
      // const skischools = this.$store.state.cart.skischools.filter(a => a.confirmed).length;

      // const sum = accomodations + addons /* + rentals */ + skipasses + skischools;

      // const rentals = this.$store.state.cart.rentals.filter(a => a.confirmed);

      // let okay = !sum;

      // rentals.forEach((rental) => {
      //   if (rental.delivery) {
      //     okay = false;
      //   }
      // });

      // return okay;
    },
    validated() {
      if (!this.site) {
        if (!this.people[0].delivery
          && this.SITE_CONFIG.accomodations.show_site && !this.$store.state.isOnSite) {
          this.$set(this.errors, 'place', true);
          return false;
        }
      }
      this.$set(this.errors, 'place', false);

      if (!this.pickupTime && this.showTimePicker) {
        this.$set(this.errors, 'time', true);
        return false;
      }
      this.$set(this.errors, 'time', false);

      if (!this.phone) {
        this.$set(this.errors, 'phone', true);
        return false;
      }

      let valid = true;

      if (this.phone.toString().match(/^\+[0-9]{9,13}$/) === null) {
        this.$set(this.errors, 'phone', true);
        valid = false;
      } else {
        this.$set(this.errors, 'phone', false);
      }

      if (this.showReceiptPicker) {
        if (this.receipt !== true && this.receipt !== false) {
          this.$set(this.errors, 'receipt', true);
          valid = false;
        } else {
          this.$set(this.errors, 'receipt', false);
        }
      }

      if (this.showInsurance) {
        const $this = this;
        let count = 0;
        this.people.forEach((person) => {
          if (person.insurance !== true && person.insurance !== false
              && $this.offerInsurance(person)) {
            $this.$set($this.errors, 'insurance', true);
            count += 1;
            valid = false;
          }
        });

        if (!count) {
          this.$set(this.errors, 'insurance', false);
        }
      }

      if (!this.productsAvailable) {
        return false;
      }

      return valid;
    },
    totalPrice() {
      return this.people.reduce((a, b) =>
        (b.insurance ? (a + this.insuranceSum(b)) : a), 0,
      );
    },
    showTimePicker() {
      if (this.SITE_CONFIG.site === 'kungsberget') {
        return false;
      }

      if (this.SITE_CONFIG.site === 'branas') {
        return false;
      }

      if (this.people[0].delivery) {
        return false;
      }

      if (this.$store.state.isOnSite && this.firstBookingIsToday) {
        return false;
      }

      // if (this.people[0].priceType === 'night') {
      //   if (this.SITE_CONFIG.site !== 'ulricehamn') {
      //     return false;
      //   }
      // }

      return true;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'saveCartLocking',
    ]),
    // openCodeModal(dontGoDirectly) {
    openCodeModal() {
      this.touch();
      if (!this.validated) {
        return false;
      }
      this.save();
      // let goDirectly = this.$store.state.isOnSite;
      // if (dontGoDirectly) {
      //   goDirectly = false;
      // }

      return true;
      // return this.openModal(['Checkout_deprecated_CodeModal', {
      //   goToPayment: this.validCode,
      //   goDirectly,
      // }]);
    },
    unmarkInsuranceError() {
      this.markInsurance = false;
    },
    offerInsurance(person) {
      if (person.onlySkipass) {
        return false;
      }

      let hasInsuredProducts = false;

      person.products.forEach((product) => {
        if (product.insurance_enabled) {
          hasInsuredProducts = true;
        }
      });

      person.addons.forEach((product) => {
        if (product.insurance_enabled) {
          hasInsuredProducts = true;
        }
      });

      if (!hasInsuredProducts) {
        return false;
      }

      return true;
    },
    insuranceSum(person) {
      if (!this.offerInsurance(person)) {
        return 0;
      }

      const days = person.days;
      let keyWith = `price_insurance_${days}`;
      let keyWithout = `price_${days}`;

      if (person.priceType === 'night') {
        keyWith = `${keyWith}_night`;
        keyWithout = `${keyWithout}_night`;
      }

      if (!this.SITE_CONFIG.rental.insurance_per_product) {
        let productWith = 0;
        let productWithout = 0;

        if (person.products.length) {
          productWithout = Math.round(parseFloat(person.products[0][keyWithout]));
          productWith = Math.round(parseFloat(person.products[0][keyWith]));
        } else if (person.addons.length) {
          productWithout = Math.round(parseFloat(person.addons[0][keyWithout]));
          productWith = Math.round(parseFloat(person.addons[0][keyWith]));
        }

        return productWith - productWithout;
      }

      const productsWithout = person.products.reduce((a, b) =>
        (a + Math.round(parseFloat(b[keyWithout] || 0))), 0,
      );
      const addonsWithout = person.addons.reduce((a, b) =>
        (a + Math.round(parseFloat(b[keyWithout] || 0))), 0,
      );

      const productsWith = person.products.reduce((a, b) =>
        (a + Math.round(parseFloat(b[keyWith] || 0))), 0,
      );
      const addonsWith = person.addons.reduce((a, b) =>
        (a + Math.round(parseFloat(b[keyWith] || 0))), 0,
      );

      const sumWithout = productsWithout + addonsWithout;
      const sumWith = productsWith + addonsWith;

      return sumWith - sumWithout;
    },
    save() {
      this.fixPhone();
      this.$store.state.cart.receipt = this.receipt;
      if (this.params.done) {
        this.params.done({
          pickupTime: this.pickupTime,
          site: this.site,
          phone: this.phone,
          onlySave: true,
        });
      }
    },
    async addToCart(pay) {
      this.fixPhone();
      this.$store.state.cart.receipt = this.receipt;

      this.touch();
      if (!this.validated) {
        return false;
      }

      let url = '/locks/reserve';
      if (this.$store.state.lockingCode) {
        url = `${url}/${this.$store.state.lockingCode}`;
      }
      const { before_time, code } = await API.get(url); // eslint-disable-line

      this.saveCartLocking({
        code,
        beforeTime: before_time,
      });

      if (this.params.done) {
        this.params.done({
          pickupTime: this.pickupTime,
          site: this.site,
          phone: this.phone,
          payDirect: pay,
        });
      }

      if (this.$store.state.isOnSite) {
        this.openModal(['OnSitePayment']);
      }

      return true;
    },
    addToCartAndPay() {
      this.addToCart(true);
    },
    validCode() {
      if (!this.validated) {
        return false;
      }

      this.$store.state.cart.receipt = this.receipt;

      if (this.params.done) {
        this.params.done({
          pickupTime: this.pickupTime,
          site: this.site,
          phone: this.phone,
          noRedirect: true,
        });
      }

      return true;
    },
    fixPhone() {
      this.phone = this.phone.replace(/^0/, '+46').replace(/^\+460/, '+46').replace(/[^+\w]/g, '');
    },
    showError(key) {
      return this.errors[key] && this.touched[key];
    },
    touch() {
      this.$set(this.touched, 'place', true);
      this.$set(this.touched, 'time', true);
      this.$set(this.touched, 'phone', true);
      this.$set(this.touched, 'insurance', true);
      this.$set(this.touched, 'receipt', true);
      return this.validated;
    },
    async checkAvailability() {
      if (this.SITE_CONFIG.site === 'vallasen' || this.SITE_CONFIG.site === 'ulricehamn') {
        const { data, message } = await API.frontendHelper('/skirental/availability', {
          cart: this.$store.state.cart,
        });

        this.productsAvailable = data;

        const $this = this;

        if (!data) {
          this.openModal(['GeneralModal', {
            zIndex: 20,
            title: 'Storlek',
            content: message,
            buttons: [
              {
                title: 'Okej',
                class: 'small',
                click: () => {
                  $this.closeAllModals();
                },
              },
            ],
          }]);
        }
      } else {
        this.productsAvailable = true;
      }
    },
    openPdf() {
      window.open('https://cdn.branasgruppen.se/branas/app/uploads/2019/12/12110225/IPID_Skidbodarna_20190701-tosj.pdf', '_blank');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'


.uppercase
  uppercase()

.disabled
  disabled()

.box
  border-radius 3px
  background-color #ffffff
  border solid 1px #c2dbe2
  margin-bottom 20px
  &.box-error
    border-color warning

label
  font-size: 11px

.places
  display: flex
  flex-wrap: wrap;
  uppercase()
  font-size 11px
  max-width: 310px
  .icon
    margin-right: 5px
  & > *
    padding space-2
    padding-right 40px
    border-right solid 1px #c2dbe2
    &:first-child
      border-bottom: 0px solid #c2dbe2
      +max-mobile()
        border-bottom: 1px solid #c2dbe2
        border-right: 0px
    &:nth-child(2)
      padding-left 20px
      border-right 0
    +max-mobile()
      width 100%
      padding-left 20px !important
      padding-right 10px !important

.required-notice
  top 15px
  right 15px
  font-size: 12px;
  font-weight: 300;
  color: #1c1c1c;
  text-align: right
  position: relative;
  top: -13px
  right: -4px
  span
    font-size: 14px;
    color: #ae1116;
    vertical-alignt super


.insurance
  border-radius 2px
  background-color rgba(236, 245, 248, 0.5)
  border solid 1px #bfd9e1
  p
    font-size: 13px
    font-weight: 300
  & > *
    padding 0 space-3 0 space-3
    +max-mobile()
      padding 0 padding-mobile 0 padding-mobile
    &:first-child
      padding-top 15px
  .checkbox-wrapper
    margin-right: 15px

h3
  font-family Interstate
  font-size 14px
  font-weight bold
  color #262626
  em, i
    font-style: normal;
    display: inline-block;
    margin-left 15px
.price
  font-family Interstate
  font-size 21px
  font-weight bold
  color #262626

.insurance-table
  border-top solid 1px light-blue-grey
  border-radius 4px 4px 0px 0px
  border-radius 4px
  width 100%
  padding 0
  .tr
    padding-left space-3
    padding-right space-3
    display: flex;
    justify-content: space-between;
    border-bottom solid 1px light-blue-grey
    padding-top 5px
    padding-bottom 5px
    +max-mobile()
      padding-left padding-mobile
      padding-right padding-mobile
    &:nth-child(odd)
      background-color: white
    &:last-child
      border-bottom: 0
    & > *
      width 33%
      &.name
        width 55%
      &:first-child
        padding-top: 8px

        & b
          display: inline-block;
          margin-left: 15px
      &.checkboxes
        width 47%
        text-align: right
        .radio-wrapper
          margin-left 15px
      font-family Interstate
      font-size 13px
      font-weight 300
      color #262626
      padding 4px 10px
      border-radius 2px
      &.children-price,
      &.keycard-price
        & > *
          font-size: 1.2em
      span
        font-size 8px
  .summarizer
    & > *
      width 100%
      text-align: right
    span
      font-size 12px
      font-weight 300
      color #262626
      uppercase()
      margin-right 0px
    b
      font-size 18px
      font-weight bold
  .offsetter
    margin-left -25px

.box.checkboxes,
.box.phone
  padding 1rem 2rem 0.5rem 0.5rem;
  display flex
  flex-wrap: wrap;
  &.phone
    padding: 0px;
    border: solid 0px #c2dbe2;
  &.box-error
    input
      border-color warning !important
    input
      background-color: #fff;
      border: solid 1px light-blue;
  label
    width 100%
  & > div
    width 90px
    margin-right 20px
    text-align center
    border-right: 1px solid #c2dbe263;
    +max-mobile()
      margin-right: 2px;
      width: 80px;
    &.phone-number
      margin: 0px
      width: 100%
      text-align: left;
      margin-top: 10px
      border-right: 0px solid #c2dbe263;
      font-size: 11px


input
  input()
  width 100%
  max-width 100%

.info
  padding 10px
  p
    margin-bottom 0

.margin-bottom
  margin-bottom: 6px

.receipt-wrapper
  .box.checkboxes > div
    width auto
    margin-left 20px
    margin-right 10px

</style>



// WEBPACK FOOTER //
// SkiRentalConfirm.vue?2a84aa3a